import React from 'react';
import ReactDOM from 'react-dom';
import {PlannerListApp} from "./apps/PlannerListApp";

let plannerListRoots = document.getElementsByClassName('plannerListRoot');

[].forEach.call(plannerListRoots, function(plannerListRoot){

    const layout = plannerListRoot.getAttribute('data-layout');
    const travelTypePreset = plannerListRoot.getAttribute('data-traveltype-preset') || '';
    const travelCategoryPreset = plannerListRoot.getAttribute('data-travelcategory-preset') || '';
    const selectedChannelPreset = plannerListRoot.getAttribute('data-selectedchannel-preset') || '';
    const monthsPreset = plannerListRoot.getAttribute('data-months-preset') || '';
    const travelLabelPreset = plannerListRoot.getAttribute('data-travellabel-preset') || '';
    const travelAreaPreset = plannerListRoot.getAttribute('data-travelarea-preset') || '';
    const travelAreaCountriesPreset = plannerListRoot.getAttribute('data-travelareacountries-preset');
    const itineraryPrintBaseUrl = plannerListRoot.getAttribute('data-itinerary-print-base-url') || '';
    const itineraryPrintListUrl = plannerListRoot.getAttribute('data-itinerary-print-list-url') || '';
    const itineraryPrintTeaserUrl = plannerListRoot.getAttribute('data-itinerary-print-teaser-url') || '';
    const favouriteLink = plannerListRoot.getAttribute('data-page-favourites');
    const shipPreset = plannerListRoot.getAttribute('data-ship-preset') || '';

    let travelAreaPresetInt = 0;
    if (travelAreaPreset !== "") {
        travelAreaPresetInt = parseInt(travelAreaPreset, 10);
    }

    let travelAreaCountriesPresetArray = []
    if (travelAreaCountriesPreset && travelAreaCountriesPreset !== '') {
        travelAreaCountriesPresetArray = travelAreaCountriesPreset.split(',').map(travelAreaCountries => parseInt(travelAreaCountries, 10));
    }

    let shipPresetInt = 0;
    if (shipPreset !== "") {
        shipPresetInt = parseInt(shipPreset, 10)
    }

    ReactDOM.render(
        <PlannerListApp
            layout={layout}
            travelAreaPreset={travelAreaPresetInt}
            travelAreaCountriesPreset={travelAreaCountriesPresetArray}
            travelTypePreset={travelTypePreset}
            travelCategoryPreset={travelCategoryPreset}
            selectedChannelPreset={selectedChannelPreset}
            monthsPreset={monthsPreset}
            travelLabelPreset={travelLabelPreset}
            shipPreset={shipPresetInt}
            itineraryPrintBaseUrl={itineraryPrintBaseUrl}
            itineraryPrintListUrl={itineraryPrintListUrl}
            itineraryPrintTeaserUrl={itineraryPrintTeaserUrl}
            favouriteLink={favouriteLink}
        />,
        plannerListRoot
    );
});


// WEBPACK FOOTER //
// ./src/plannerList.js